export enum EvaluationStatusEnum {
  ERROR = "ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
  SUCCESS = "SUCCESS",
  UPLOADING = "UPLOADING"
}
